var state = {
  // Note: the setting of defaultSelectedCurtainProperties loaded from GK-new-4/decisions.json/defaultSelectedLogProperties will overwrite this.
  selectedLogQuantities: ["GR", "NPHI", "RHOB", "RT_NEW"]
};
var getters = {};
var actions = {};
var mutations = {
  updateSelectedLogQuantities: function updateSelectedLogQuantities(state, value) {
    state.selectedLogQuantities = value;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};